// extracted by mini-css-extract-plugin
module.exports = {"main":"CardModel_main__Stzya"};